import { useParams } from "react-router-dom";
import { Detail } from "../../../components/templates/Detail.tsx";

export default function TemplatesIDPage() {
  const params = useParams();

  return (
    <div className="w-full h-full p-8">
      <Detail templateId={params.id!} />
    </div>
  );
}
